import { Box, Button, Stack, Typography } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import CareDetailsIcons from 'src/assets/images/care-needs/care-details-icons.avif';
import SagePedalsBackground from 'src/assets/images/care-needs/sage-pedal-background-2.avif';
import PageFooter from 'src/components/PageFooter';
import PageHeader from 'src/components/PageHeader';
import { useTeamMemberData } from 'src/hooks/useTeamMemberData';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';
import { getTeamMemberDisplayName } from 'src/utils/nameUtils';

export const Route = createFileRoute('/(app)/care/day-to-day/intro')({
    component: AdlsDayToDayIntroComponent,
});

function AdlsDayToDayIntroComponent() {
    const navigate = useNavigate();

    const { careRecipient } = useTeamMemberData();

    const handleContinue = () => {
        navigate({ to: '/care/day-to-day/memory' });
    };

    return (
        <InnerMaxWidthContainer
            wrapperPropsSx={{
                backgroundImage: `url(${SagePedalsBackground})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top right',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
            }}
        >
            <PageHeader />
            <Box
                sx={{
                    pb: 6,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    animation: 'fadeSlideIn 0.6s ease-out',
                    '@keyframes fadeSlideIn': {
                        from: {
                            opacity: 0,
                            transform: 'translateY(-20px)',
                        },
                        to: {
                            opacity: 1,
                            transform: 'translateY(0)',
                        },
                    },
                }}
            >
                <Box
                    component="img"
                    src={CareDetailsIcons}
                    alt="Care Details Icons"
                    sx={{ width: '100%', height: '100%', maxWidth: '400px' }}
                />
            </Box>
            <Stack sx={{ gap: 2 }}>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                    Now, tell us about{' '}
                    {getTeamMemberDisplayName(careRecipient, {
                        firstOnly: true,
                        usePreferred: true,
                    })}{' '}
                    as an individual.
                </Typography>
                <Typography variant="body1">
                    We will ask you questions around memory, mobility, food, and interests.
                </Typography>
                <Typography variant="body1">
                    Add details of what is most relevant for giving{' '}
                    {getTeamMemberDisplayName(careRecipient, {
                        firstOnly: true,
                        usePreferred: true,
                    })}{' '}
                    personalized care.
                </Typography>
            </Stack>
            <PageFooter>
                <Button variant="contained" color="primary" fullWidth onClick={handleContinue}>
                    Got it
                </Button>
            </PageFooter>
        </InnerMaxWidthContainer>
    );
}
